import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ImageAndCallToActionsBlockConfig } from '@front-platform/content-builder';
import { imageAndCallToActionsBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldImage } from '@core/models/content-builder-fields.model';
export interface ImageAndCallToActionsBlockRuntimeConfig {
  'buttons'?: unknown[];
  '"button-size-y"'?: 'S' | 'M' | 'L';
}

export type ImageAndCallToActionsBlockConfigInput = Partial<
  Omit<ImageAndCallToActionsBlockConfig, keyof ImageAndCallToActionsBlockRuntimeConfig> &
    ImageAndCallToActionsBlockRuntimeConfig
>;
export type ImageAndCallToActionsBlockResolvedConfig = Omit<
  ImageAndCallToActionsBlockConfig,
  keyof ImageAndCallToActionsBlockRuntimeConfig
> &
  Partial<ImageAndCallToActionsBlockRuntimeConfig>;
export interface ImageAndCallToActionsBlockContract extends ConfigComponentContract<
  ImageAndCallToActionsBlockConfigInput,
  ImageAndCallToActionsBlockResolvedConfig
> {}

@Component({
  selector: 'app-image-and-call-to-actions-block',
  templateUrl: './image-and-call-to-actions-block.component.html',
  standalone: false,
})
export class ImageAndCallToActionsBlockComponent implements ImageAndCallToActionsBlockContract {
  readonly config = input<ImageAndCallToActionsBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ImageAndCallToActionsBlockConfig,
    ImageAndCallToActionsBlockRuntimeConfig
  >(imageAndCallToActionsBlockResolveConfig, () => ({ config: this.config() }));
  get anchor(): string | undefined {
    return this.resolvedConfig()['anchor'] as unknown as string | undefined;
  }
  get textOnImage(): string | undefined {
    return this.resolvedConfig()['text_on_image'] as unknown as string | undefined;
  }
  get textContent(): string | undefined {
    return this.resolvedConfig()['text_content'] as unknown as string | undefined;
  }
  get imagePosition(): string | undefined {
    return this.resolvedConfig()['image_position'] as unknown as string | undefined;
  }
  get buttons(): unknown[] {
    return this.resolvedConfig()['buttons'] as unknown as unknown[];
  }
  get urlButtonImage(): string | undefined {
    return this.resolvedConfig()['url_button_image'] as unknown as string | undefined;
  }
  get labelButtonImage(): string | undefined {
    return this.resolvedConfig()['label_button_image'] as unknown as string | undefined;
  }
  get image(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['image'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get buttonSizeY(): 'S' | 'M' | 'L' {
    return this.resolvedConfig()['"button-size-y"'] as unknown as 'S' | 'M' | 'L';
  }

  IMAGE_POSITION_RIGHT = 'right';
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ImageAndCallToActionsBlockComponent, {
  'keyAliases': { 'button_size_y': '"button-size-y"' },
});
